// extracted by mini-css-extract-plugin
module.exports = {"colorPopup":"#363738","colorBackground05":"rgba(42,45,44,0.5)","list":"FooterSocials_list__16hs_","item":"FooterSocials_item__3OgqW","img":"FooterSocials_img__1Tp6y"};